import { refChildren } from "@/composables/reactive";
import { storeToRefs } from "pinia";
import { useDevicePreferencesStore } from "@/store/device-preferences-store";

const cache = new Map<string, HTMLAudioElement>();

export function getAudio(file: string, useCache = true): HTMLAudioElement {
    let audio: HTMLAudioElement;
    if (useCache && cache.has(file)) {
        audio = cache.get(file);
    } else {
        audio = new Audio(`/static-assets/sounds/${file}.mp3`);
        if (useCache) cache.set(file, audio);
    }
    return audio;
}

export const useSoundFx = () => {
    const devicePrefsStore = useDevicePreferencesStore();
    const { preferences } = storeToRefs(devicePrefsStore);
    const {
        sound_note,
        sound_noteMy,
        sound_antenna,
        sound_channel,
        sound_notification,
        sound_masterVolume,
        sound_chatBg,
        sound_chat,
    } = refChildren(preferences);

    const sounds = {
        note: sound_note,
        noteMy: sound_noteMy,
        notification: sound_notification,
        chat: sound_chat,
        chatBg: sound_chatBg,
        antenna: sound_antenna,
        channel: sound_channel,
    };

    function setVolume(
        audio: HTMLAudioElement,
        volume: number
    ): HTMLAudioElement {
        audio.volume =
            sound_masterVolume.value - (1 - volume) * sound_masterVolume.value;
        return audio;
    }

    function play(type: keyof typeof sounds) {
        const sound = sounds[type].value;
        if (sound.type == null) return;
        playFile(sound.type, sound.volume);
    }

    function playFile(file: string, volume: number) {
        if (
            sound_masterVolume.value === 0 ||
            volume === 0 ||
            file.toLowerCase().includes("none")
        )
            return;

        const audio = setVolume(getAudio(file), volume);
        audio.play();
    }

    return { setVolume, play, playFile };
};
